import React, { useState,useRef, useEffect } from 'react';
import DiscountType from '../../Class/DiscountTypes';
import axios from 'axios';
import AppStrings from '../../config/appstring';
import PayModeList from '../../Class/PayModeList';
import FeesPrint from '../Print/FeesPrint';

const initialSections = [
  {
    id: 'apr2025',
    headerValues: ['apr2025', 27850, 0, '', 27850, 27850,'Discount Type','Remarks'],
    data: [
      { id: 1, label: 'Term I Fees', values: [24400, 0, 'D', 24400, 24400,'',''] },
      { id: 2, label: 'Transports', values: [3450, 0, 'D', 3450, 3450,'',''] },
    ],
  },
  {
    id: 'may2025',
    headerValues: ['may2025', 30000, 1000, '', 29000, 29000,'Discount Type','Remarks'],
    data: [
      { id: 3, label: 'Term II Fees', values: [25000, 0, 'D', 24000, 24000,'',''] },
      { id: 4, label: 'Bus Fees', values: [5000, 0, 'D', 5000, 5000,'',''] },

{ id: 5, label: 'Bus Fees', values: [5000, 0, 'D', 5000, 5000,'',''] },    ],
  },
];


const initialSections1 = [
  {
  "Admission ID": "A100",
  "Name": "Keerthi",
  "Old Pending": {
    "Fees": 15000,
    "Discount": 500,
    "Paid": 4500,
    "Pending": 10000
  },
  "1st Term": {
    "Fees": 10000,
    "Discount": 0,
    "Paid": 2000,
    "Pending": 8000
  }
}

];


export default function MultiTable({ onClose,studentData,value, onChange }) {
  const [tableData, setTableData] = useState([]);
  const [checkedMap, setCheckedMap] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalRowId, setModalRowId] = useState(null);
  const [modalRowLabel, setModalRowLabel] = useState('');
  const [modalDiscountInput, setModalDiscountInput] = useState('');
  const [textInputs, setTextInputs] = useState({});
 const [tempDiscount, setTempDiscount] = useState('');
    const discountInputRef = useRef(null);
    const [tempDiscountType, setTempDiscountType] = useState('');
const [tempDiscountRemarks, setTempDiscountRemarks] = useState('');
const [showConfirmModal, setShowConfirmModal] = useState(false);
const [printRefNo, setPrintRefNo] = useState(null);
const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
const [classOptions, setClassOptions] = useState([]);

const [payModeList, setPayModeList] = useState('');
const [overAllRemarks, setOverAllRemarks] = useState('');
const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    // Initialize textInputs for 4th column input (index 4)
    console.log(studentData)
    const initialInputs = {};
    tableData.forEach(sec => {
      sec.data.forEach(row => {
        //initialInputs[row.id] = row.values[4];
         const value = row.values[4];
          console.log(value,'vvvvvvvvvvvvvvvvv')
        initialInputs[row.id] = value === '' || value === null || value === undefined ? 0 : value;
      });
    });
    setTextInputs(initialInputs);
  }, [tableData]);

      // useEffect(() => {
          
      //   }, []);
  
        useEffect(() => {
   

    fetchClassDetails();

     if (studentData?.admissionDate) {
    setAdmissionDate(studentData.admissionDate);
  }
          handlePayClick();
  }, []); // Empty dependency array to fetch data once on component mount


   const fetchClassDetails = async () => {
      try {
        const response = await fetch(AppStrings.PayModeList);
        const data = await response.json(); // Assuming the response is in JSON format

        if (data.success === 200 && Array.isArray(data.data)) {
          setClassOptions(data.data); // Set the class options
        } else {
          console.error('Invalid data format received:', data);
        }
      } catch (error) {
        console.error('Error fetching class details:', error);
      }
    };

  const handlePayClick = async () => {
   // console.log(studentData.id,'sssssssssssss')
    
    const url = AppStrings.AllFeesDetails+`?studentid=${studentData.id}`;

    try {
      const response = await axios.get(url);
      const result = response.data.data.result || response.data.data;
//console.log(result,'llllllllllllllllllll');
      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ 
          ...item, 
          current: '',
           discount: '' ,
           discountType: '', // <-- add this line
  discountRemark: '',
        }));
         //setMode('pay');
       // setSelectedRow(row);
        setTableData(withEditable);
      } else {
       // alert(`No fee records found for ${row.NAME}`);
        alert(`No fee records found for HIIIII`);
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      alert("Failed to fetch fee details.");
    }
  };



  const toggleAll = (sectionId, rows) => {
    const allChecked = checkedMap[sectionId]?.all;
    const newRows = rows.reduce((a, row) => ({ ...a, [row.id]: !allChecked }), {});
    setCheckedMap({
      ...checkedMap,
      [sectionId]: { all: !allChecked, rows: newRows },
    });
  };

  const toggleRow = (sectionId, rowId, rows) => {
    const sec = checkedMap[sectionId] || { all: false, rows: {} };
    const newRows = { ...sec.rows, [rowId]: !sec.rows[rowId] };
    const all = rows.every(r => newRows[r.id]);
    setCheckedMap({ ...checkedMap, [sectionId]: { all, rows: newRows } });
  };

  // Calculate total (using the 5th column values and text inputs)
  const getTotal = () => {
    let sum = 0;
    tableData.forEach(sec =>
      sec.data.forEach(row => {
        if (checkedMap[sec.id]?.rows?.[row.id]) {
          let val = textInputs[row.id];
          val = parseFloat(val);
           if (val === '' || val === null || val === undefined) {
          val = 0;
        } else {
          val = parseFloat(val);
          if (isNaN(val)) val = 0;
        }
          sum += val;
        }
      })
    );
    return sum;
  };

  const getSelectedFeeDetails = () => {
  const selectedFees = [];

  tableData.forEach(sec => {
    sec.data.forEach(row => {
      const isChecked = checkedMap[sec.id]?.rows?.[row.id];
      if (isChecked) {
        const original = row.values;

        const current = textInputs[row.id];
        const parsedCurrent = parseFloat(current);
        const finalCurrent = isNaN(parsedCurrent) ? 0 : parsedCurrent;

        selectedFees.push({
          TYPE: row.label,
          FEES: original[0],
          current: finalCurrent,
          discount: original[1],
          discountType: original[5],
          discountRemark: original[6],
          PayType:original[7],
          Place:original[8],
        });
      }
    });
  });

  return selectedFees;
};

  const handleSubmit = async () => {
  const feeDetails = getSelectedFeeDetails(); // Extract selected rows

  if (feeDetails.length === 0) {
    alert("No rows selected.");
    return;
  }

  const payload = {
  
    student: {
      id: studentData.id,
      admissionDate: admissionDate || '', // Make sure this exists in studentData
      type: studentData.addfees,
      PayMode: payModeList,
OverAllRemark: overAllRemarks,
 USERNAME:studentData.username
    },
    schoolfees: feeDetails.filter(({ current, discount,PayType }) => {
      const paid = parseFloat(current) || 0;
      const off = parseFloat(discount) || 0;
      return paid + off > 0 && PayType=='A';
    }),
     busfees: feeDetails.filter(({ current, discount,PayType }) => {
      const paid = parseFloat(current) || 0;
      const off = parseFloat(discount) || 0;
      return paid + off > 0 && PayType=='T';
    }),
    
  };

  try {
    console.log(payload,'zzzzzzzzzzzzzzzaaaaaaaaaaaaaaaa')
    const res = await fetch(AppStrings.SaveToFeesDetails, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    //console.log()
    const result = await res.json();
    console.log(result.data.REFNO, "-------->");
    setPrintRefNo(result.data.REFNO);
    
    alert(result.message || "Data saved successfully!");
 setIsSubmitted(true);
    // Optional: clear state or close modal
    //onClose();

  } catch (err) {
    console.error("Error:", err);
    alert("Failed to save data.");
  }
};


  const handleCollect = () => {
    alert(`Collecting total: ₹${getTotal()}`);
  };

  const openModal = (id, label) => {
    setModalRowId(id);
    setModalRowLabel(label);
    // Find discount value from values[2] if it's a number, else blank
    let discountVal = '';
    tableData.forEach(sec => {
      sec.data.forEach(row => {
        if (row.id === id) {
          const val = row.values[2];
          if (typeof val === 'number') discountVal = val;
        }
      });
    });
    setTempDiscount(discountVal);
    setModalOpen(true);
  };

  const saveDiscount = () => {
    const val = parseFloat(tempDiscount);
    if (isNaN(val) || val < 0) return alert('Invalid discount');

    // Update discount in 3rd column (index 2) of the row in tableData
    const newTableData = tableData.map(sec => {
      return {
        ...sec,
        data: sec.data.map(row => {
          if (row.id === modalRowId) {
            const newValues = [...row.values];
            newValues[1] = val; // Set discount value here
            newValues[3] =newValues[0]- val;
            newValues[4] =newValues[0]- val;
            newValues[5]=tempDiscountType;
            newValues[6]=tempDiscountRemarks;
            return { ...row, values: newValues };
          }
          return row;
        }),
      };
    });

    setTableData(newTableData);
    setModalOpen(false);
  };

  const handleYesNo = () => {
  setShowConfirmModal(true);
};
  

  return (
     <div style={modalOverlayStyle}>  
          <div style={modalStyle}>
    <div>
      {onClose && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <button style={closeButtonStyle} onClick={onClose}>
          ×
        </button>
        </div>
      )}
      <div>Name:{studentData.name} <br/>Id:{studentData.id}</div>
      
       <div className="row">
        <div className="col-25">
        <div className="col-25">
        
            <div className="coolinput">
          {/* <label for="input" class="text">Admission Date:</label> */}
            <input
              required
              type="date"
              name="DOADM"
              autoComplete="off"
              className="input"
              value={admissionDate}
              onChange={(e) => setAdmissionDate(e.target.value)}
            />
            
            </div> 
          </div> 
           <div className="col-75">
        
            <div className="coolinput">
          {/* <label for="input" class="text">Admission Date:</label> */}
           <select  style={{ height: '40px' }}
        name="PAYMODELIST"
       value={payModeList}
  onChange={(e) => setPayModeList(e.target.value)}
        className="input"
        autoComplete="off"
      >
        <option value="">PAY MODE</option>
        {classOptions.map((classItem, index) => (
          <option key={index} value={classItem.TYPE}>
            {classItem.TYPE || ''}
          </option>
        ))}
      </select>
            
            </div> 
          </div> 
          </div>
          <div className="col-25">
        <div className="col-25">
        
            <div className="coolinput">
          {/* <label for="input" class="text">Admission Date:</label> */}
            <input
              required
              type="text"
              placeholder='Remarks'
              name="OverAllRemarks"
              value={overAllRemarks}
  onChange={(e) => setOverAllRemarks(e.target.value)}
              autoComplete="off"
              className="input"
            />
            
            </div> 
          </div> 
          
          </div>
          </div>
          <br/>
<div style={scrollContainerStyle}>
      <table style={{ ...tableStyle, tableLayout: 'fixed' }}>
        <colgroup>
          <col style={{ width: '50px' }} /> {/* Checkbox */}
          <col style={{ width: '250px' }} /> {/* Label */}
          <col style={{ width: '100px' }} /> {/* 3rd col - discount */}
          <col style={{ width: '100px' }} /> {/* 4th col */}
          <col style={{ width: '10px' }} /> {/* 5th col input */}
          <col style={{ width: '100px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
          <col style={{ width: '150px' }} />
        </colgroup>

         <thead>
    <tr  style={{ backgroundColor: '#f2f2f2' }}>
      <th style={{ ...headerCellStyle}}></th>
      <th style={{ ...headerCellStyle}}>OLD PENDING</th>
      <th style={{ ...headerCellStyle}}>TOTAL FEE</th>
      <th style={{ ...headerCellStyle}}>DISCOUNT</th>
      <th style={{ ...headerCellStyle}}></th>
      <th style={{ ...headerCellStyle}}>AMOUNT</th>
      <th style={{ ...headerCellStyle}}>PAID</th>
      <th style={{ ...headerCellStyle}}>DISCOUNT TYPE</th>
      <th style={{ ...headerCellStyle}}>REMARKS</th>
      <th style={{ ...headerCellStyle}}>TYPE</th>
      <th style={{ ...headerCellStyle}}>PLACE</th>
    </tr>
  </thead>

        <tbody>
          {tableData.map(sec => (
            <React.Fragment key={sec.id}>
              <tr style={headerRowStyle}>
                <td>
                  <input
                    type="checkbox"
                    checked={checkedMap[sec.id]?.all || false}
                    onChange={() => toggleAll(sec.id, sec.data)}
                  />
                </td>
                {sec.headerValues.map((v, i) => (
                  <td key={i} style={centerText}>
                    {i === 0 ? <div>{v}</div> : v}
                  </td>
                ))}
              </tr>

              {sec.data.map(row => (
                <tr  key={row.id}>
                  <td style={{ textAlign: 'left', paddingLeft: '25px' }}>
                    <input
                      type="checkbox"
                      checked={checkedMap[sec.id]?.rows?.[row.id] || false}
                      onChange={() => toggleRow(sec.id, row.id, sec.data)}
                    />
                  </td>
                  <td>{row.label}</td>
                  {row.values.map((v, i) => {
                    if (v === 'D') {
                      return (
                        <td key={i} style={{ ...centerText, textAlign: 'left', paddingRight: '8px' }}>
                          <button
                            style={plusButtonStyle}
                            onClick={() => openModal(row.id, row.label)}
                          >
                            +
                          </button>
                        </td>
                      );
                    }

                    // 5th column (index 4) as input
                    if (i === 4) {
                      return (
                        <td key={i} style={centerText}>
                          <input
                            value={textInputs[row.id] !== undefined ? textInputs[row.id] : v}
                            onChange={e =>
                              setTextInputs(prev => ({
                                ...prev,
                                [row.id]: e.target.value,
                              }))
                            }
                            style={inputStyle}
                            disabled={!checkedMap[sec.id]?.rows?.[row.id]}
                          />
                        </td>
                      );
                    }


                    return (
                      <td key={i} style={centerText}>
                        {v}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
</div>
      <div style={footerStyle}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <strong>Total to Collect: ₹{getTotal()}</strong></div>
         <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <button onClick={handleYesNo} disabled={getSelectedFeeDetails().length === 0 || isSubmitted} style={collectButtonStyle}>
          Collect ₹{getTotal()}
        </button>
        </div>
      </div>

      {modalOpen && (
          <div style={modalOverlayStyle}>
            <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
                <h3>Discount Type</h3>
             <DiscountType
    //   value={formData.PLACE} // Controlled value for the select dropdown
    //     onChange={handleFormChange} // Handle change to update formData
     value={tempDiscountType}
  onChange={(val) => setTempDiscountType(val)}
      />

              <h3>Enter Discount</h3>
               <div class="coolinput">
                          <input
                          ref={discountInputRef}
                            type="text"
                            placeholder="Discount Amount"
                            className="input PayInPut"
                            value={tempDiscount}
                            onChange={(e) => setTempDiscount(e.target.value)}
                          />
                          </div>
                          <h3>Remarks</h3>
               <div class="coolinput">
                          <input
                    
                            type="text"
                            placeholder="Remarks"
                            className="input PayInPut"
                            value={tempDiscountRemarks}
                            onChange={(e) => setTempDiscountRemarks(e.target.value)}
                          />
                          </div>
                          
            
              <div style={{ marginTop: '15px' }}>
                <button onClick={saveDiscount}>Save</button>
                <button onClick={() => setModalOpen(false)} style={{ marginLeft: '10px' }}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showConfirmModal && (
  <div style={modalOverlayStyle}>
    <div style={{ ...modalStyle, width: '300px', textAlign: 'center' }}>
      <h3>Confirm Save</h3>
      <p>Are you sure you want to save this data?</p>
      <div style={{ marginTop: '15px' }}>
        <button
          onClick={() => {
            setShowConfirmModal(false);
            handleSubmit(); // ✅ proceed with actual submission
          }}
        >
          Yes
        </button>
        <button
          onClick={() => setShowConfirmModal(false)}
          style={{ marginLeft: '10px' }}
        >
          No
        </button>
      </div>
    </div>
  </div>
)}

{printRefNo && (
  <div style={modalOverlayStyle}>
    <div style={modalStyle}>
      <FeesPrint
              RefNo={printRefNo}
              onClose={() => {
                setPrintRefNo(null); // ✅ close the print modal
                onClose();           // ✅ now close the full form
              }}
            />
    </div>
  </div>
)}

      {/* {modalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h4>Discount for {modalRowLabel}</h4>
            <input
              type="number"
              value={modalDiscountInput}
              onChange={e => setModalDiscountInput(e.target.value)}
              style={inputStyle}
            />
            <div style={modalActionsStyle}>
              <button onClick={() => setModalOpen(false)} style={cancelButtonStyle}>
                Cancel
              </button>
              <button onClick={saveDiscount} style={saveButtonStyle}>
                Save
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
    </div>
    </div>
  );
}

const headerCellStyle = {
//  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};


const scrollContainerStyle=
{
   maxHeight: '350px',
  maxWidth: '100%',
  overflowY: 'auto',
  overflowX: 'auto',
  border: '1px solid #ccc',
}

// ... styles unchanged from your original code
const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '70%',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const tableStyle = {
   width: '1000px', // Fixed width to enable horizontal scroll
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
  fontSize:'15PX'
};

const headerRowStyle = {
  color:'#3fabe5',
  fontWeight: 'bold',
};

const centerText = {
  textAlign: 'center',
};

const greenText = {
  textAlign: 'right',
  color: 'green',
};

const footerStyle = {
  marginTop: 12,
};

const collectButtonStyle = {
  marginLeft: 12,
  padding: '6px 12px',
  background: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
};

const plusButtonStyle = {
  fontSize: 16,
  padding: '2px 6px',
  borderRadius: '4px',
  border: '1px solid #007bff',
  backgroundColor: '#fff',
  color: '#007bff',
  cursor: 'pointer',
  width:'30px'
};

const closeButtonStyle = {
  marginBottom: 10,
  padding: '6px 10px',
  background: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  color:'black'
};

const modalOverlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  
};

const modalContentStyle = {
  backgroundColor: '#fff',
  padding: 20,
  borderRadius: 4,
  width: 300,
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const inputStyle = {
  width: '90%',
  margin: 10,
  padding: 8,
  fontSize: 14,
  borderRadius: 4,
  border: '1px solid #ccc',
  boxSizing: 'border-box',
};

const modalActionsStyle = {
  textAlign: 'right',
};

const cancelButtonStyle = {
  marginRight: 10,
  padding: '6px 12px',
  backgroundColor: '#f0f0f0',
  border: '1px solid #ccc',
  borderRadius: 4,
  cursor: 'pointer',
};

const saveButtonStyle = {
  padding: '6px 12px',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
};
